<template>
    <b-overlay :show="busy" rounded="sm">
        <!-- {{ search }}<br /><br />
      {{ item }} -->
        <b-card class="standardpage reports invoices border-none">

            <div class="availtable datatable text-left">
                <b-card-body class="py-0">
                    <b-tabs class="gridtabs">
                        <b-tab :active="true">
                            <template #title>
                                <div class="badgecontainer pr-5">
                                    <i :class="options.icon" class="text-primary mr-1"></i>
                                    <span class="text-center badgenormal badge-secondary badge-pill">
                                        {{ item.ipaddress }}
                                    </span>
                                    <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit"
                                        }}&gt;</span>
                                </div>
                            </template>
                            <p class="py-3 px-0">

                                <b-row>
                                    <b-col cols="12">
                                        <b-form-group label="IP Addresses ( ip1, ip2-ip3, ip4/32 )"
                                            label-for="ipaddress" label-cols="12">
                                            <b-input-group class="treeselect_all" style="left:180px; top:-13px">
                                                <i id="ipaddress" class="fa fa-info-circle text-black"></i>
                                            </b-input-group>
                                            <b-tooltip target="ipaddress" triggers="hover" placement="top">Provide an IP address or an IP address range using CIDR notation (e.g. 192.168.0.99/24). You can also provide a comma-separated list of IP addresses.
                                                </b-tooltip>
                                            <b-form-textarea id="ipaddress" v-model="item.ipaddress"
                                                placeholder="IP Addresses ( ip1, ip2-ip3, ip4/32 )" rows="2"
                                                class="smalltextarea">
                                            </b-form-textarea>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="6" xl="6">
                                        <b-form-group label="IP Ports" label-for="ipports" label-cols="12"
                                            label-size="sm">
                                            <treeselect v-model="item.ipports" :clearable="true"
                                                :options="options_ipports" :multiple="true" :disabled="true">
                                            </treeselect>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Email" label-for="email" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.email" placeholder="Enter email"
                                                    size="sm" disabled="true"></b-form-input>
                                                <!-- <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary" @click="item.user = ''"
                                                        disabled="true">
                                                        <i class="fa fa-remove"></i>
                                                    </b-button>
                                                </b-input-group-append> -->
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Department" label-for="department" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.department"
                                                    placeholder="Enter department" size="sm"
                                                    disabled="true"></b-form-input>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </p>
                        </b-tab>

                    </b-tabs>
                </b-card-body>
                <b-card-footer class="nopadding mt-2">
                    <b-row no-gutters>
                        <b-col cols="auto" class="text-left mr-3">
                            <b-button squared size="sm" variant="primary" @click="saveit">
                                <i class="fa fa-check"></i>
                                Save It
                            </b-button>
                        </b-col>
                        <b-col class="text-left my-auto">
                            <div v-if="busy">
                                <i class="fa fa-spinner fa-spin text-primary"></i>
                            </div>
                            <div v-else>
                                <span v-html="message"></span>
                            </div>
                        </b-col>
                        <b-col class="text-right" cols="8">
                            <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
                                <i class="fa fa-chevron-left pr-1"></i>
                                Back
                            </b-button>
                        </b-col>
                    </b-row>
                </b-card-footer>

            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";

import moment from "moment";

export default {
    name: "WHFEdit",
    data() {
        return {
            busy: false,

            item: {
                ipaddress: null,
                ipports: [],
                email: "",
                department: "",
                // method: "md5"
            },
            options_ipports: [
                { id: "1433", label: "1433 | SQL Server" },
                { id: "5432", label: "5432 | Postgres" },
                { id: "5000", label: "5000 | RDP Alternate" }
            ],
            options: {
                title: "Working From Home",
                icon: "fa fa-laptop",
            },
        };
    },
    watch: {
        selection() {
            this.load();
        },
    },
    methods: {
        async load() {
            let variables = {
                id: this.idselected,

            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query setup_users($id: String) {
                            setup_users(id: $id) {
                                id
                                ipaddress
                                ipports                 
                                email
                                department
                            }
                        }
                    `,
                    variables,
                });

                if (response.data.setup_users.length > 0) {
                    this.item = response.data.setup_users[0];

                    this.item.ipports = this.item.ipports ? this.item.ipports.split(",") : [];
                }
            } catch (error) {
                console.log(error);
            }
            this.busy = false;
        },
        async saveit() {

            this.busy = true;


            let variables = { rows: [this.cleanit(this.item)] };
            if (variables.rows[0].ipports) {
                variables.rows[0].ipports = this.item.ipports.join(",")
            }
            console.log("variables", variables);

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
              mutation setup_users_save(
                $rows: [setup_users_input]              
              ) {
                setup_users_save(rows: $rows) {
                  id                             
                }
              }
            `,
                    variables,
                });

                let emailto = await this.$helpers.getsystemsetting("firewall_emailto");
                if (!emailto) { emailto = "" }

                if (!emailto.includes(this.item.email)) {
                    if (emailto.length > 0) {
                        emailto += ","
                    }
                    emailto += this.item.email
                    await this.setsystemsetting("firewall_emailto", emailto)
                }

                this.message = "<span class='text-primary'>Saved it.</span>";

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },      

    },
};
</script>

<style></style>